import React from 'react';
import classNames from 'classnames';
import {
  FolderIcon,
  HelpCircleIcon,
  HomeIcon,
  ImageIcon,
  LayoutGridIcon,
  MoonIcon,
  PlusIcon,
  StarIcon,
  SunIcon,
} from 'lucide-react';
import { CanvopixTheme } from '../../types';
import { Theme } from '@shared/theme';

export function Icon(props: { children: React.ReactNode; className?: string }) {
  return <span className={classNames('inline-flex h-5 w-5 items-center justify-center', props.className)}>{props.children}</span>;
}

export function IconHome() {
  return (
    <Icon>
      <HomeIcon className="h-5 w-5" />
    </Icon>
  );
}

export function IconFolder() {
  return (
    <Icon>
      <FolderIcon className="h-5 w-5" />
    </Icon>
  );
}

export function IconGrid() {
  return (
    <Icon>
      <LayoutGridIcon className="h-5 w-5" />
    </Icon>
  );
}

export function IconHelp() {
  return (
    <Icon>
      <HelpCircleIcon className="h-5 w-5" />
    </Icon>
  );
}

export function IconPlus() {
  return (
    <Icon>
      <PlusIcon className="h-5 w-5" />
    </Icon>
  );
}

export function IconImage() {
  return (
    <Icon>
      <ImageIcon className="h-5 w-5" />
    </Icon>
  );
}

export function IconTheme(props: { theme: Theme }) {
  if (props.theme === 'dark') {
    return (
      <Icon>
        <MoonIcon className="h-5 w-5" />
      </Icon>
    );
  }

  if (props.theme === 'radiant') {
    return (
      <Icon>
        <StarIcon className="h-5 w-5" />
      </Icon>
    );
  }

  return (
    <Icon>
      <SunIcon className="h-5 w-5" />
    </Icon>
  );
}
